<template>
    <el-dialog :title="title" :visible.sync="innerVisible" width="950px" @close="$emit('update:visible', false);"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <div v-loading="loading" :element-loading-text=promptText element-loading-spinner="el-icon-loading"
            style="min-height: 200px;">
            <component v-show="currentComp" height="calc(100vh - 215px)" :visible.sync="innerVisible" v-bind="$attrs"
                v-on="$listeners" :is="currentComp" @loadingPopupWindow="loadingPopupWindow" />
        </div>
    </el-dialog>
</template>

<script>
import { capabilityRegistry } from './introduceComponents.js'

export default {
    name: 'ModalContainer',

    props: {
        visible: Boolean,
        // 👇 只传字符串
        capabilityKey: {
            type: String,
            default: ''
        },
        title: String,
    },

    data() {
        return {
            innerVisible: false,
            loading: false,
            promptText: this.$t('common.loadingEllipsis'),
            currentComp: null
        }
    },

    watch: {
        visible(val) {
            this.innerVisible = val
        },

        capabilityKey: {
            immediate: true,
            async handler(key) {
                if (!key) return
                const loader = capabilityRegistry[key]

                if (!loader) {
                    console.error(`[ModalContainer] 未找到组件：${key}`)
                    return
                }
                const mod = await loader()
                this.currentComp = mod.default || mod
            }
        },
    },
    methods: {
        // 内部 input 触发时自动调用父组件传入的 onInput
        loadingPopupWindow(type, string = this.$t('common.loadingEllipsis')) {
            this.loading = type
            this.promptText = string
        }
    },
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body {
    box-sizing: border-box;
    padding: 8px 0px 8px 32px;
}

/deep/ .el-dialog__title {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
}
</style>